import { ComplexBotComponent } from "../complex-bot.component";
import { Component, ContentChild, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { SpinnerComponent } from "../../../elements/spinner/spinner.component";

@Component({
    selector: "my-complex-bot-config",
    templateUrl: "config-screen.complex-bot.component.html",
    styleUrls: ["config-screen.complex-bot.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, NgTemplateOutlet]
})
export class ConfigScreenComplexBotComponent {
    @Input() botComponent: ComplexBotComponent<any>;
    @ContentChild(TemplateRef, { static: false })
    botParamsTemplate: TemplateRef<any>;
}
